import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  boxTitle: {
    backgroundColor: theme.palette.primary.light,
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
  },
  alertBox: {
    borderRadius: 2,
    backgroundColor: theme.palette.background.snackbar,
    border: `1px solid ${theme.palette.custom.border}`,
    padding: theme.spacing(1),
  },
}))

export default useStyles
